export const OPEN_COOKIE_PREFERENCES_EVENT = 'scrolled:open-cookie-preferences';

export const openCookiePreferences = () => {
  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
};
